import { isErrorFileState, isFileIdentifier } from '@atlaskit/media-client';
var getProcessingStatusFromFileState = function getProcessingStatusFromFileState(status) {
  switch (status) {
    case 'processed':
      return 'succeeded';
    case 'processing':
      return 'running';
    case 'failed-processing':
      return 'failed';
  }
};
var getFileDetailsFromFileState = function getFileDetailsFromFileState(state) {
  return {
    id: state.id,
    name: state.name,
    size: state.size,
    mimeType: state.mimeType,
    createdAt: state.createdAt,
    mediaType: state.mediaType,
    processingStatus: getProcessingStatusFromFileState(state.status)
  };
};
export var getFileDetails = function getFileDetails(identifier, fileState) {
  return isFileIdentifier(identifier) ? fileState && !isErrorFileState(fileState) ? getFileDetailsFromFileState(fileState) : {
    id: identifier.id
  } : {
    id: identifier.mediaItemType,
    name: identifier.name || identifier.dataURI,
    mediaType: 'image'
  };
};